'use client';

import {motion} from 'framer-motion';
import Link from 'next/link';
import useTopStyle from '../../utils/useTopStyle';
import heroVariants from '../../animation/heroVariants';

// export const metadata = {
//     title: 'Legal — Cylerian',
//     description: 'Links to our legal documents: Terms, Privacy, Cookies, Licenses and more.',
// };

const docs = [
    { href: 'https://rightofboom.com/', title: 'Right of Boom 2026', desc: '2/3/2026-Las Vegas', type: 'conference' },
    { href: 'https://www.channelpronetwork.com/defend', title: 'ChannelPro: DEFEND', desc: '2/17/2026-Orlando', type: 'conference' },
    { href: 'https://www.channelpronetwork.com/live', title: 'ChannelPro: LIVE', desc: '4/7/2026-Columbus', type: 'conference' },
    { href: 'https://www.channelpronetwork.com/live', title: 'ChannelPro: LIVE', desc: '5/5/2026-Chicago', type: 'conference' },
    { href: 'https://www.channelpronetwork.com/defend', title: 'ChannelPro: DEFEND', desc: '9/1/2026-Alexandria', type: 'conference' },
    { href: 'https://www.channelpronetwork.com/live', title: 'ChannelPro: LIVE', desc: '10/13/2026-Dallas', type: 'conference' },
    { href: 'https://www.channelpronetwork.com/defend', title: 'ChannelPro: DEFEND', desc: '11/9/2026-Anaheim', type: 'conference' },
];

export default function LegalPage() {
    const ref = useTopStyle(72);

    return (

        <div className='legal-page'>
            <section
                className='company-hero'
                ref={ref}
            >
                <div className='container'>
                    <h2 className='title'>
                        {`Where's`}
                        <span className='highlight'> Cylerian</span>
                    </h2>
                    <p className='text'>
                  {`We're taking Unified Security Operations to the stages that shape our industry—conferences, workshops, and virtual events where the future gets built. Connect with us live. Whether you're discovering Cylerian for the first time or deepening an existing partnership, this is where the critical conversations happen. Be part of them.`}
                    </p>
                </div>
            </section>

            <section className='double legal-docs'>
                <div className='container'>
                    <div className='inner-container'>
                        <ul className='legal-list'>
                            {docs.map((doc,index) => (
                                <li key={`${doc.href}-${index}`} className='legal-item'>
                                    <Link href={doc.href} legacyBehavior>
                                        <a className='legal-link'>
                                            <div className='card-top'>
                                                <span className='chip chip-event'>
                                                    Event
                                                </span>
                                                <span className='arrow-wrapper'>
                                                    <span className='arrow'></span>
                                                </span>
                                            </div>
                                            <h3 className='legal-title'>{doc.title}</h3>
                                            <p className='legal-desc'>{doc.desc}</p>
                                        </a>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
}